import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  return inject(AuthService)
    .check()
    .pipe(
      // Erro transitório (rede/5xx) ao validar a sessão: os tokens continuam válidos, então não mandamos para o sign-in
      // (que leva ao WhatsApp). A página offline oferece "Tentar novamente".
      catchError(() => of(router.parseUrl('/offline'))),
      switchMap((authenticated: boolean | UrlTree) => {
        if (authenticated instanceof UrlTree) return of(authenticated);

        if (!isPlatformBrowser(platformId)) {
          return of(true);
        }

        // Se o usuário não estiver autenticado e estiver acessando uma rota autenticada
        if (!authenticated) {
          const urlTree: UrlTree = router.parseUrl(`${state.url === '/sign-out' ? 'sign-out' : 'sign-in'}`);

          return of(urlTree);
        }

        // TODO V2: Adicionar validação se o usuário pode ter acesso a essa rota

        // Acesso permitido
        return of(true);
      })
    );
};
